import { Roles } from "../../../../mp-utils/generic-utils"
import { statesByValueLabel } from "../../../../mp-utils/ready-utils"
import { AnnouncementsItemType } from "../../../../mp-database/contextHelpManager"

export const ANNOUNCEMENT_TYPES = {
  announcements: [
    "WHATS_NEW",
    "GENERAL",
    "CUSTOM",
    "ALERT",
    "FEEDBACK_REQUEST"
  ],
  tips: ["TIP"],
  "help-boxes": ["HELP_ARTICLES"]
}
export const ANNOUNCEMENT_PICKER_TYPES = ["WHATS_NEW", "GENERAL", "ALERT"]
export const LEARN_MORE_TYPES = ["MODAL", "LINK"]
export const PRIORITY_TYPES = [
  { key: 1, label: "1 - Highest" },
  { key: 2, label: "2" },
  { key: 3, label: "3" },
  { key: 4, label: "4" },
  { key: 5, label: "5 - Lowest" }
]

export const FREQUENCY_TYPES = ["PERSIST", "ONCE", "HOURLY", "DAILY", "WEEKLY"]
export const programs = ["ACT", "SAT", "PSAT", "TSIA2", "STAAR"]

export const ALL_PROGRAMS_OPTION = "All Programs"

export const ALL_ROLES_OPTION = "All Roles"
export const ROLE_OPTIONS = [
  ALL_ROLES_OPTION,
  Roles.Super_Administrator,
  Roles.ACT_Admin,
  Roles.ACT_Multi_District_Admin,
  Roles.District_Admin,
  Roles.School_Admin,
  Roles.Instructor,
  Roles.Teacher,
  Roles.Student,
  Roles.Course_Author
]

export const ALL_STATES_OPTION = "All States"
export const STATES_OPTIONS = [
  {
    value: ALL_STATES_OPTION,
    label: ALL_STATES_OPTION
  },
  ...statesByValueLabel
]

export const ALERT_TONE_TYPES = ["INFO", "SUCCESS", "WARNING", "ERROR"]

export const PLACEMENT_TYPES = ["TOP", "BODY"]

export enum AudienceLocation {
  AllLocations = "All Locations",
  TruscorePracticeTests = "TruScore",
  BubbleSheet = "Bubble Sheet",
  StudyHall = "Study Hall",
  Mastery = "Mastery",
  Elements = "Elements",
  SnapCourse = "SnapCourse",
  ManageOrganization = "Manage",
  ManageDistricts = "Manage::Districts",
  ManageDistrictAdmins = "Manage::District Admins",
  ManageSchools = "Manage::Schools",
  ManageSchoolAdmins = "Manage::School Admins",
  ManageTeachers = "Manage::Teachers",
  ManageClasses = "Manage::Classes",
  ManageStudents = "Manage::Students",
  ManagePlatform = "Platform",
  ManageSystemConfiguration = "Platform::System Configuration",
  ManagePlatformSettings = "Platform::Platform Settings",
  ManageWhitelisting = "Platform::Whitelisting",
  ManageSaml = "Platform::SAML",
  ManageOneroster = "Platform::OneRoster",
  StudyPlan = "Study Plan",
  StudyPlanHome = "Study Plan::Home",
  StudyPlanStudyPlans = "Study Plan::Study Plans",
  StudyPlanInsights = "Study Plan::Insights",
  ContextHelpManager = "Context Help Manager",
  EBooks = "eBooks",
  Login = "Login",
  Reporting = "Reporting",
  ReportingInsights = "Reporting::Insights",
  ReportingContent = "Reporting::Content",
  ReportingOrganization = "Reporting::Organization",
  ReportingTeachingTools = "Reporting::Teaching Tools",
  ReportingTeachingToolsStudyPlan = "Reporting::Teaching Tools::Study Plan",
  ReportingTeachingToolsBellRingers = "Reporting::Teaching Tools::Bell Ringers",
  ReportingTeachingToolsTestAdministration = "Reporting::Teaching Tools::Test Administration",
  ReportingTeachingToolsMasteryCurriculum = "Reporting::Teaching Tools::Mastery Curriculum",
  ReportingTeachingToolsSkillReview = "Reporting::Teaching Tools::Skill Review",
  ReportingTeachingToolsBooks = "Reporting::Teaching Tools::Books",
  StudentExperience = "Student Experience",
  StudentExperienceDashboard = "Student Experience::Dashboard",
  StudentExperienceStudyPlan = "Student Experience::Study Plan",
  StudentExperienceInsights = "Student Experience::Insights",
  StudentExperiencePracticeTests = "Student Experience::Practice Tests",
  StudentExperienceSkillReview = "Student Experience::Skill Review",
  StudentExperienceMasteryCurriculum = "Student Experience::Mastery Curriculum"
}

export const AudienceLocationsWithoutProgram = [
  AudienceLocation.ManageOrganization,
  AudienceLocation.ManageDistricts,
  AudienceLocation.ManageDistrictAdmins,
  AudienceLocation.ManageSchools,
  AudienceLocation.ManageSchoolAdmins,
  AudienceLocation.ManageTeachers,
  AudienceLocation.ManageClasses,
  AudienceLocation.ManageStudents,
  AudienceLocation.ManageSystemConfiguration,
  AudienceLocation.ManagePlatform,
  AudienceLocation.ManagePlatformSettings,
  AudienceLocation.ManageWhitelisting,
  AudienceLocation.ManageSaml,
  AudienceLocation.ManageOneroster,
  AudienceLocation.ContextHelpManager,
  AudienceLocation.Login,
  AudienceLocation.Reporting,
  AudienceLocation.ReportingOrganization,
  AudienceLocation.ReportingTeachingToolsTestAdministration,
  AudienceLocation.StudentExperience
]

export const AudienceLocationNotAuthPathKeys = {
  [AudienceLocation.Login]: [
    "login",
    "signin",
    "reset",
    "schoology",
    "auth",
    "logged-out",
    "invites"
  ]
}

export const AudienceLocationAuthPathKeys = {
  [AudienceLocation.TruscorePracticeTests]: ["truscore"],
  [AudienceLocation.StudyHall]: ["truscore", "study-hall"],
  [AudienceLocation.Mastery]: ["mastery"],
  [AudienceLocation.Elements]: ["snap", "elements"],
  [AudienceLocation.SnapCourse]: ["snap"],
  [AudienceLocation.ManageOrganization]: ["manage"],
  [AudienceLocation.ManageDistricts]: ["manage", "districts"],
  [AudienceLocation.ManageDistrictAdmins]: ["manage", "district-admins"],
  [AudienceLocation.ManageSchools]: ["manage", "schools"],
  [AudienceLocation.ManageSchoolAdmins]: ["manage", "school-admins"],
  [AudienceLocation.ManageTeachers]: ["manage", "teachers"],
  [AudienceLocation.ManageClasses]: ["manage", "classes"],
  [AudienceLocation.ManageStudents]: ["manage", "students"],
  [AudienceLocation.ManagePlatform]: ["reporting", "configuration"],
  [AudienceLocation.ManageSystemConfiguration]: ["reporting", "configuration"],
  [AudienceLocation.ManagePlatformSettings]: [
    "reporting",
    "configuration",
    "platform-settings"
  ],
  [AudienceLocation.ManageWhitelisting]: [
    "reporting",
    "configuration",
    "whitelisting"
  ],
  [AudienceLocation.ManageSaml]: ["reporting", "configuration", "saml"],
  [AudienceLocation.ManageOneroster]: [
    "reporting",
    "configuration",
    "oneroster"
  ],
  [AudienceLocation.StudyPlan]: ["eoc"],
  [AudienceLocation.StudyPlanHome]: ["eoc", "dashboard"],
  [AudienceLocation.StudyPlanStudyPlans]: ["eoc", "study-plans"],
  [AudienceLocation.StudyPlanInsights]: ["eoc", "insights"],
  [AudienceLocation.ContextHelpManager]: ["context-help-manager"],
  [AudienceLocation.EBooks]: ["ebooks"],
  [AudienceLocation.Reporting]: ["reporting"],
  [AudienceLocation.ReportingInsights]: ["reporting", "insights"],
  [AudienceLocation.ReportingContent]: ["reporting", "content"],
  [AudienceLocation.ReportingOrganization]: ["reporting", "organization"],
  [AudienceLocation.ReportingTeachingTools]: ["reporting", "teaching-tools"],
  [AudienceLocation.ReportingTeachingToolsStudyPlan]: [
    "reporting",
    "teaching-tools",
    "study-plan"
  ],
  [AudienceLocation.ReportingTeachingToolsBellRingers]: [
    "reporting",
    "teaching-tools",
    "bell-ringers"
  ],
  [AudienceLocation.ReportingTeachingToolsTestAdministration]: [
    "reporting",
    "teaching-tools",
    "test-administration"
  ],
  [AudienceLocation.ReportingTeachingToolsMasteryCurriculum]: [
    "reporting",
    "teaching-tools",
    "mastery-curriculum"
  ],
  [AudienceLocation.ReportingTeachingToolsSkillReview]: [
    "reporting",
    "teaching-tools",
    "skill-review"
  ],
  [AudienceLocation.ReportingTeachingToolsBooks]: [
    "reporting",
    "teaching-tools",
    "books"
  ],
  [AudienceLocation.StudentExperience]: ["student-experience"],
  [AudienceLocation.StudentExperienceDashboard]: [
    "student-experience",
    "dashboard"
  ],
  [AudienceLocation.StudentExperienceStudyPlan]: [
    "student-experience",
    "study-plan"
  ],
  [AudienceLocation.StudentExperienceInsights]: [
    "student-experience",
    "insights"
  ],
  [AudienceLocation.StudentExperiencePracticeTests]: [
    "student-experience",
    "practice-tests"
  ],
  [AudienceLocation.StudentExperienceSkillReview]: [
    "student-experience",
    "skill-review"
  ],
  [AudienceLocation.StudentExperienceMasteryCurriculum]: [
    "student-experience",
    "mastery-curriculum"
  ]
}

export const LOCATION_OPTIONS = [
  {
    value: AudienceLocation.AllLocations,
    label: "All Locations",
    level: 0
  },
  {
    value: AudienceLocation.TruscorePracticeTests,
    label: "TruScore",
    level: 0
  },
  {
    value: AudienceLocation.StudyHall,
    label: "Study Hall",
    level: 0
  },
  {
    value: AudienceLocation.Mastery,
    label: "Mastery",
    level: 0
  },
  { value: AudienceLocation.Elements, label: "Elements", level: 0 },
  {
    value: AudienceLocation.SnapCourse,
    label: "SnapCourse",
    level: 0
  },
  {
    value: AudienceLocation.ManageOrganization,
    label: "Manage",
    level: 0
  },
  {
    value: AudienceLocation.ManageDistricts,
    label: "Districts",
    level: 1,
    groupName: AudienceLocation.ManageOrganization
  },
  {
    value: AudienceLocation.ManageDistrictAdmins,
    label: "District Admins",
    level: 1,
    groupName: AudienceLocation.ManageOrganization
  },
  {
    value: AudienceLocation.ManageSchools,
    label: "Schools",
    level: 1,
    groupName: AudienceLocation.ManageOrganization
  },
  {
    value: AudienceLocation.ManageSchoolAdmins,
    label: "School Admins",
    level: 1,
    groupName: AudienceLocation.ManageOrganization
  },
  {
    value: AudienceLocation.ManageTeachers,
    label: "Teachers",
    level: 1,
    groupName: AudienceLocation.ManageOrganization
  },
  {
    value: AudienceLocation.ManageClasses,
    label: "Classes",
    level: 1,
    groupName: AudienceLocation.ManageOrganization
  },
  {
    value: AudienceLocation.ManageStudents,
    label: "Students",
    level: 1,
    groupName: AudienceLocation.ManageOrganization
  },
  {
    value: AudienceLocation.ManagePlatform,
    label: "Configuration",
    level: 0
  },
  {
    value: AudienceLocation.ManagePlatformSettings,
    label: "Platform Settings",
    level: 1,
    groupName: AudienceLocation.ManagePlatform
  },
  {
    value: AudienceLocation.ManageWhitelisting,
    label: "Whitelisting",
    level: 1,
    groupName: AudienceLocation.ManagePlatform
  },
  {
    value: AudienceLocation.ManageSaml,
    label: "SAML 2.0",
    level: 1,
    groupName: AudienceLocation.ManagePlatform
  },
  {
    value: AudienceLocation.ManageOneroster,
    label: "OneRoster",
    level: 1,
    groupName: AudienceLocation.ManagePlatform
  },
  { value: AudienceLocation.StudyPlan, label: "Study Plan", level: 0 },
  {
    value: AudienceLocation.StudyPlanHome,
    label: "Home",
    level: 1,
    groupName: AudienceLocation.StudyPlan
  },
  {
    value: AudienceLocation.StudyPlanStudyPlans,
    label: "Study Plans",
    level: 1,
    groupName: AudienceLocation.StudyPlan
  },
  {
    value: AudienceLocation.StudyPlanInsights,
    label: "Insights",
    level: 1,
    groupName: AudienceLocation.StudyPlan
  },
  {
    value: AudienceLocation.ContextHelpManager,
    label: "Context Help Manager",
    level: 0
  },
  { value: AudienceLocation.EBooks, label: "eBooks", level: 0 },
  { value: AudienceLocation.Login, label: "Login", level: 0 },
  {
    value: AudienceLocation.Reporting,
    label: "Reporting",
    level: 0
  },
  {
    value: AudienceLocation.ReportingInsights,
    label: "Insights",
    level: 1,
    groupName: AudienceLocation.Reporting
  },
  {
    value: AudienceLocation.ReportingContent,
    label: "Content",
    level: 1,
    groupName: AudienceLocation.Reporting
  },
  {
    value: AudienceLocation.ReportingOrganization,
    label: "Organization",
    level: 1,
    groupName: AudienceLocation.Reporting
  },
  {
    value: AudienceLocation.ReportingTeachingTools,
    label: "Teaching Tools",
    level: 1,
    groupName: AudienceLocation.Reporting
  },
  {
    value: AudienceLocation.ReportingTeachingToolsStudyPlan,
    label: "Study Plan",
    level: 2,
    groupName: AudienceLocation.ReportingTeachingTools
  },
  {
    value: AudienceLocation.ReportingTeachingToolsBellRingers,
    label: "Bell Ringers",
    level: 2,
    groupName: AudienceLocation.ReportingTeachingTools
  },
  {
    value: AudienceLocation.ReportingTeachingToolsTestAdministration,
    label: "Test Administration",
    level: 2,
    groupName: AudienceLocation.ReportingTeachingTools
  },
  {
    value: AudienceLocation.ReportingTeachingToolsMasteryCurriculum,
    label: "Mastery Curriculum",
    level: 2,
    groupName: AudienceLocation.ReportingTeachingTools
  },
  {
    value: AudienceLocation.ReportingTeachingToolsSkillReview,
    label: "Skill Review",
    level: 2,
    groupName: AudienceLocation.ReportingTeachingTools
  },
  {
    value: AudienceLocation.ReportingTeachingToolsBooks,
    label: "Books",
    level: 2,
    groupName: AudienceLocation.ReportingTeachingTools
  },
  {
    value: AudienceLocation.StudentExperience,
    label: "Student Experience",
    level: 0
  },
  {
    value: AudienceLocation.StudentExperienceDashboard,
    label: "Dashboard",
    level: 1,
    groupName: AudienceLocation.StudentExperience
  },
  {
    value: AudienceLocation.StudentExperienceStudyPlan,
    label: "Study Plan",
    level: 1,
    groupName: AudienceLocation.StudentExperience
  },
  {
    value: AudienceLocation.StudentExperienceInsights,
    label: "Insights",
    level: 1,
    groupName: AudienceLocation.StudentExperience
  },
  {
    value: AudienceLocation.StudentExperiencePracticeTests,
    label: "Practice Tests",
    level: 1,
    groupName: AudienceLocation.StudentExperience
  },
  {
    value: AudienceLocation.StudentExperienceSkillReview,
    label: "Skill Review",
    level: 1,
    groupName: AudienceLocation.StudentExperience
  },
  {
    value: AudienceLocation.StudentExperienceMasteryCurriculum,
    label: "Mastery Curriculum",
    level: 1,
    groupName: AudienceLocation.StudentExperience
  }
]

export const HELP_ARTICLES_LOCATION_OPTIONS = [
  {
    value: AudienceLocation.ManageSystemConfiguration,
    label: "System Configuration",
    level: 0
  },
  {
    value: AudienceLocation.ManageWhitelisting,
    label: "Whitelisting",
    level: 0
  },
  {
    value: AudienceLocation.ManageSaml,
    label: "SAML 2.0",
    level: 0
  },
  {
    value: AudienceLocation.ManageOneroster,
    label: "OneRoster",
    level: 0
  }
]

export const defaultRecords: Record<string, Partial<AnnouncementsItemType>> = {
  announcements: {
    startDate: Date.now(),
    endDate: Date.now() + 86400000,
    title: "",
    placement: PLACEMENT_TYPES[0],
    type: "",
    enabled: false,
    allowPermanentDismiss: false,
    priority: 3,
    frequency: FREQUENCY_TYPES[3],
    locations: [],
    programs: [],
    states: [],
    roles: []
  },
  tips: {
    startDate: Date.now(),
    endDate: Date.now() + 86400000,
    title: "",
    type: ANNOUNCEMENT_TYPES.tips[0],
    enabled: false,
    allowPermanentDismiss: false,
    priority: 3,
    frequency: FREQUENCY_TYPES[3],
    locations: [],
    programs: [],
    roles: []
  }
}

export const TITLE_SYMBOLS_LIMIT = 100
export const SUBTITLE_SYMBOLS_LIMIT = 100
export const MESSAGE_SYMBOLS_LIMIT = 250

export const CONTENT_TAB = "Content"
export const AUDIENCE_TAB = "Audience"
export const PREVIEW_TAB = "Preview"

export const TAB_ITEMS = [
  {
    label: CONTENT_TAB,
    value: CONTENT_TAB
  },
  {
    label: AUDIENCE_TAB,
    value: AUDIENCE_TAB
  },
  {
    label: PREVIEW_TAB,
    value: PREVIEW_TAB
  }
]

export const ANNOUNCEMENT_FORM_ID = "ANNOUNCEMENT_FORM_ID"

export const ONBOARDING_SURVEY_DATA = {
  imgFileRef: {
    url: "/img/onboarding-survey-background.svg"
  }
}
